import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivCreateRepairEstimateRequestDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRepairEstimateRequestControllerGetParamsGen,
  MrfiktivRepairEstimateRequestViewModelGen,
  MrfiktivUpdateRepairEstimateRequestDtoGen,
  MrfiktivUpdateRepairEstimateRequestResponseDtoGen
} from "../v1/data-contracts";
import { RepairEstimateRequest } from "../v1/RepairEstimateRequest";

/**
 * Communicate with RepairEstimateRequest API
 */
class RepairEstimateRequestService {
  mrfiktivProxy: RepairEstimateRequest;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new RepairEstimateRequest(mrfiktivHttpClientProvider.client());
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateRequestId
   * @param token
   * @returns
   */
  async getDocumentBySharedAccessToken(
    partnerId: string,
    repairEstimateRequestId: string,
    token: string
  ): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateRequestControllerFindOneWithAccessSignature({
      partnerId,
      repairEstimateRequestId,
      sct: token
    });

    return shared.data;
  }

  /**
   * Create anRepairEstimateRequest
   */
  async create(
    partnerId: string,
    data: MrfiktivCreateRepairEstimateRequestDtoGen
  ): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const repairEstimateRequest = (await this.mrfiktivProxy.repairEstimateRequestControllerCreate(partnerId, data))
      .data;

    return repairEstimateRequest;
  }

  /**
   * Get allRepairEstimateRequest
   */
  async get(
    data: MrfiktivRepairEstimateRequestControllerGetParamsGen
  ): Promise<
    MrfiktivPageViewModelGen & {
      data?: MrfiktivRepairEstimateRequestViewModelGen[];
    }
  > {
    const repairEstimateRequests = (await this.mrfiktivProxy.repairEstimateRequestControllerGet(data)).data;

    return repairEstimateRequests;
  }

  /**
   * Get a RepairEstimateRequest
   */
  async getOne(partnerId: string, repairEstimateRequestId: string): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const repairEstimateRequest = (
      await this.mrfiktivProxy.repairEstimateRequestControllerGetOne(partnerId, repairEstimateRequestId)
    ).data;

    return repairEstimateRequest;
  }

  /**
   * Update a RepairEstimateRequest
   */
  async update(
    partnerId: string,
    repairEstimateRequestId: string,
    data: MrfiktivUpdateRepairEstimateRequestDtoGen
  ): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const repairEstimateRequest = (
      await this.mrfiktivProxy.repairEstimateRequestControllerUpdate(partnerId, repairEstimateRequestId, data)
    ).data;

    return repairEstimateRequest;
  }

  /**
   *
   * Gets a report by shared access signature
   *
   * @param partnerId
   * @param repairEstimateRequestId
   * @param token
   * @param data
   * @returns
   */
  async respond(
    partnerId: string,
    repairEstimateRequestId: string,
    token: string,
    data: MrfiktivUpdateRepairEstimateRequestResponseDtoGen
  ): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const shared = await this.mrfiktivProxy.repairEstimateRequestControllerRespond(
      { partnerId, repairEstimateRequestId, sct: token },
      data
    );

    return shared.data;
  }

  /**
   * Delete a RepairEstimateRequest
   */
  async delete(partnerId: string, repairEstimateRequestId: string): Promise<MrfiktivRepairEstimateRequestViewModelGen> {
    const repairEstimateRequest = (
      await this.mrfiktivProxy.repairEstimateRequestControllerDelete(partnerId, repairEstimateRequestId)
    ).data;

    return repairEstimateRequest;
  }
}

/**
 * Communicate with RepairEstimateRequest API
 */
export default new RepairEstimateRequestService(new MrfiktivHttpClientProvider());
